export default __webpack_public_path__ + "static/media/GradeIcon.870099a2.svg";